/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Faq_Signin_AInputs */



/**
* | output |
* | --- |
* | "The partner portal uses passkeys — your fingerprint, face or device PIN — instead of a password. You can add another passkey, for example for a second device..." |
*
* @param {Partner_Faq_Signin_AInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_faq_signin_a = /** @type {((inputs?: Partner_Faq_Signin_AInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Faq_Signin_AInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Das Partnerportal verwendet Passkeys — Fingerabdruck, Gesicht oder Geräte-PIN — statt eines Passworts. Einen weiteren Passkey, zum Beispiel für ein zweites Gerät, fügen Sie unter Einstellungen › Sicherheit hinzu.")
	return /** @type {LocalizedString} */ ("The partner portal uses passkeys — your fingerprint, face or device PIN — instead of a password. You can add another passkey, for example for a second device, under Settings › Security.")
});